import { useEffect, useState } from 'react';
import { API_BASE } from '../components/Config.js';

export default function useJobTitleMatch(initialTitle = '') {
  const [jobTitle, setJobTitle] = useState(initialTitle);
  const [hasDictionaryMatch, setHasDictionaryMatch] = useState(false);

  const checkDictionaryMatch = async (title) => {
    const trimmed = title.trim();
    if (!trimmed) {
      setHasDictionaryMatch(false);
      return;
    }
    try {
      const response = await fetch(`${API_BASE}/check_job_title_match`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ job_title: trimmed }),
      });
      if (!response.ok) throw new Error('Network response was not ok');
      const data = await response.json();
      setHasDictionaryMatch(Boolean(data.has_match));
    } catch (_err) {
      setHasDictionaryMatch(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (jobTitle.trim()) {
        checkDictionaryMatch(jobTitle);
      } else {
        setHasDictionaryMatch(false);
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [jobTitle]);

  return { jobTitle, setJobTitle, hasDictionaryMatch };
}


